import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ICreateBusinessRequest, ICreateBusinessResponse } from '../models/create-business.model';

export const loadCreateBusiness = createAction('[CreateBusiness] Load CreateBusiness', props<{ request: ICreateBusinessRequest }>());

export const loadCreateBusinessSuccess = createAction('[CreateBusiness] Load CreateBusiness Success', props<{ response: string }>());

export const loadCreateBusinessFailure = createAction(
  '[CreateBusiness] Load CreateBusiness Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
